<template>
  <editor api-key="no-api-key" />
</template>

<script>
import EditorComponent from "@tinymce/tinymce-vue";

export default {
  name: "App",
  components: {
    editor: EditorComponent,
  },
};
</script>
